import { render } from "./rmxAtenderCopias.vue?vue&type=template&id=641767ab"
import script from "./rmxAtenderCopias.vue?vue&type=script&lang=js"
export * from "./rmxAtenderCopias.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/ceroPapel/cmp/rmxAtenderCopias.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "641767ab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('641767ab', __exports__)) {
    api.reload('641767ab', __exports__)
  }
  
  module.hot.accept("./rmxAtenderCopias.vue?vue&type=template&id=641767ab", () => {
    api.rerender('641767ab', render)
  })

}


export default __exports__